import React, { useState, useEffect, useRef } from 'react';
import PropTypes from "prop-types";

//MATERIAL UI
import TaskCard from "../TaskCard";
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';

import { useTranslate } from 'react-polyglot';

function RadioWizPage(props) {
    const t = useTranslate();

    const [selection, setSelection] = useState();

    function triggerPageUpdated(value = selection) {
        props.pageUpdatedCallback({
            ...props.trait,
            value: {
                option: value
            }
        });
    }

    function handleSelects(checked, option) {
        if (checked) {
            setSelection(option);
            triggerPageUpdated(option);
        }
    }

    function stringReplacer(str) {
        str = str.replace(new RegExp("(\\[dog-name\\]|%alias%)", 'g'), props.animalName);
        str = str.replace(new RegExp("(\\[han/hun\\])", 'g'), (props.animalGender == "male" ? t("registerfeatures.doggenders.he") : t("registerfeatures.doggenders.she")));
        str = str.replace(new RegExp("(\\[hans/hennes\\])", 'g'), (props.animalGender == "male" ? t("registerfeatures.doggenders.his") : t("registerfeatures.doggenders.hers")));
        str = str.replace(new RegExp("(\\[han/henne\\])", 'g'), (props.animalGender == "male" ? t("registerfeatures.doggenders.him") : t("registerfeatures.doggenders.her")));
        return str;
    }

    useEffect(() => {
        if (props.trait.value != undefined) {
            try {
                let value = JSON.parse(props.trait.value);
                setSelection(value.option);
            } catch (ex) {
                console.debug("no resume value");
            }
        }
    }, [props.trait.value]);

    return (
        <React.Fragment>
            <div style={{ display: props.display ? "block" : "none" }}>
                <TaskCard
                    taskCounter={props.trait.traitName}
                    taskHeader=""
                    noInfo={props.trait.traitInfoName == "" ? true : undefined}
                    taskBody={stringReplacer(props.trait.traitDescription)}
                    style={{overflow: "visible"}}
                    taskInfoHeader={stringReplacer(props.trait.traitInfoName)}
                    taskInfoBody={stringReplacer(props.trait.traitInfoDescription)}
                    children={
                        <div className="checkboxes-container" >
                            {props.trait.options.map((option, key) => 
                                <FormControlLabel
                                    key={key}
                                    value="bottom"
                                    control={
                                        <Radio
                                            color="primary"
                                            name={"radioid-" + props.trait.traitId}
                                            onChange={(e, checked) => handleSelects(checked, option)}
                                            checked={selection == option}
                                        />
                                    }
                                    label={stringReplacer(option)}
                                    labelPlacement="bottom"
                                />
                            )}
                        </div>
                    }
                />
            </div>
        </React.Fragment>
    );
}

RadioWizPage.propTypes = {
    trait: PropTypes.object,
    pageUpdatedCallback: PropTypes.func,
    display: PropTypes.bool
};

export default RadioWizPage;